import { useMemo } from "react";

import { useStore } from "../../stores/StoreContext";
import { CurrentUserService } from "../LogicServices/CurrentUserService";

export function useCurrentUserService(): CurrentUserService {
  const storeContext = useStore();
  return useMemo(() => new CurrentUserService(storeContext), [storeContext]);
}
